<!--师资介绍列表-->
<template>
  <div class="teacherIntroduceList">
    <div
      class="teacherIntroduceItem"
      v-for="(item, index) in teacherListData"
      :key="index"
      @click="teacherDetail(item)"
    >
      <!--      <img :src="item.teacherHead||defaultImg" alt="">-->
      <div class="img-div">
        <van-image
          fit="contain"
          round
          :src="item.teacherHead || require('../../../assets/img/loginImg/default.png')"
        />
      </div>
      <div>
        <h3>{{ item.publicName }}</h3>
        <p class="teacherMajors">{{ item.teachMainModule }}</p>
        <p>{{ item.teacherBrief }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Vue from 'vue';
import { Image as VanImage } from 'vant';
import { setBaseUrl } from '@/utils/tools';
import { reqTeacherList } from '../../../api/courseDetail/index';
// import defaultImg from '../../../assets/img/loginImg/default.png';

Vue.use(VanImage);

export default {
  components: {},
  data() {
    return {
      teacherListData: [],
      soltidsList: [],
      defaultImg: '../../../assets/img/loginImg/default.png', // 师资头像为空时展示默认
    };
  },
  computed: {
    ...mapState(['courseBaseData']),
  },
  watch: {
    courseBaseData(v) {
      if (v) {
        this.getTeacherList();
      }
    },
  },
  mounted() { },
  methods: {
    async getTeacherList() {
      let idsList = [];
      const attributeList = this.courseBaseData.productAttributeRespVOS || [];
      attributeList.forEach((element) => {
        if (element.extendAttributeNameEn === 'teacher') {
          idsList = JSON.parse(element.dataJson);
          this.soltidsList = element.dataJson;
        }
      });
      if (!idsList.length) return;
      const res = await reqTeacherList(idsList);
      if (res.code === 0 && res.data) {
        this.teacherListData = res.data;
        this.teacherListData.sort((prev, next) => {
          const p = this.soltidsList.indexOf(prev.id);
          const n = this.soltidsList.indexOf(next.id);
          return p - n;
        });
      }
    },
    teacherDetail(item) {
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          { url: `${setBaseUrl('')}/ark/teacherDetail?teacherId=${item.id}` },
          false,
        );
        return;
      }
      this.$router.push({
        path: '/teacherDetail',
        query: { teacherId: item.id, source: 'branch' },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.teacherIntroduceList {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 36px;
  background-color: #fff;
  .teacherIntroduceItem {
    display: flex;
    width: 100%;
    margin-bottom: 30px;
    padding: 36px;
    background-color: #fffaf7;
    border-radius: 14px;
    .img-div {
      flex: 0 0 auto;
      width: 87px;
      height: 87px;
      margin-right: 20px;
    }
    ::v-deep img {
      flex-shrink: 0;
      width: 87px;
      height: 87px;
      margin-right: 20px;
    }
    div {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      h3 {
        color: #333;
        font-weight: 500;
        font-size: 33px;
        line-height: 50px;
      }
      p {
        color: #787878;
        font-size: 25px;
        line-height: 38px;
        text-align: justify;
      }
      .teacherMajors {
        padding: 6px 0 10px;
      }
    }
  }
}
</style>
